import { render, staticRenderFns } from "./AdditionalInformation.vue?vue&type=template&id=4d0d1cbc&scoped=true"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInformation.vue?vue&type=style&index=0&id=4d0d1cbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d1cbc",
  null
  
)

export default component.exports